module.exports = __webpack_public_path__ + "img/weixin.5ea0f575.png";